import * as React from 'react';
import { Redirect } from 'react-router';

import { RouterError } from '../../app/spaces/RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { Favorites } from '../../content/resources/Favorites';
import { Flows } from '../../ts/resources/Flows';

export interface FlowSpaceFavoriteRedirectProps {
  readonly flowId: string;
  readonly urls: SpacesSiteUrls;
}

type FlowStatus = 'unfetched' | 'fetched' | 'error';

export const FlowSpaceFavoriteRedirect: React.FunctionComponent<FlowSpaceFavoriteRedirectProps> = props => {
  const [ flowStatus, setFlowStatus ] = React.useState<FlowStatus>('unfetched');

  React.useEffect(() => {
    let didCancel = false;

    fetchFlow(props.flowId)
      .then(() => !didCancel && setFlowStatus('fetched'))
      .catch(() => {
        removeFavoriteFlow(props.flowId);
        !didCancel && setFlowStatus('error');
      });

    return () => didCancel = true;
  }, []);

  if (flowStatus === 'unfetched') {
    return null;
  } else if (flowStatus === 'fetched') {
    return <Redirect to={props.urls.flowPath(props.flowId)}/>;
  } else {
    return <RouterError errorType={'flow-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchFlow(flowId: string): Promise<FlowDetailInfo> {
  return Flows.getById(flowId);
}

function removeFavoriteFlow(flowId: string) {
  Favorites.remove(flowId, 'flow');
}
